import { Link } from "react-router-dom";

const CTA_BG =
  "https://readdy.ai/api/search-image?query=warm%20editorial%20moody%20artistic%20illustration%20of%20a%20cream%20colored%20vintage%20moving%20truck%20driving%20through%20a%20brownstone%20brooklyn%20neighborhood%20at%20golden%20hour%20with%20long%20warm%20shadows%20painterly%20texture%20deep%20burnt%20orange%20and%20rich%20earth%20tone%20palette%20cinematic%20wide%20composition%20professional%20moving%20company%20aesthetic%20with%20soft%20golden%20directional%20sunset%20light&width=1800&height=900&seq=site-cta-bg&orientation=landscape";

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img src={CTA_BG} alt="" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink-900/85 via-ink-900/70 to-ink-900/40"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl text-white">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 backdrop-blur border border-white/20 text-xs font-semibold mb-5">
            <i className="ri-flashlight-line text-brand-300"></i>
            <span>Quotes returned in under an hour</span>
          </div>
          <h4 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight mb-5">
            <a href="#cta" className="text-white hover:text-white no-underline">
              Ready to make moving day boring?
            </a>
          </h4>
          <p id="cta" className="text-base md:text-lg text-white/80 leading-relaxed mb-8">
            Tell us a little about your move and we'll send you a transparent, all-in quote — usually within the hour. No call-center pressure, no upsells.
          </p>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Link
              to="/site/contact"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-semibold bg-brand-500 hover:bg-brand-600 text-white cursor-pointer whitespace-nowrap transition-colors"
            >
              Request a Free Quote
              <i className="ri-arrow-right-line"></i>
            </Link>
            <a
              href="tel:+13475550142"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-semibold bg-white/10 hover:bg-white/15 backdrop-blur border border-white/20 text-white cursor-pointer whitespace-nowrap transition-colors"
            >
              <i className="ri-phone-line"></i>
              Talk to a Human
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}